import React, { ReactNode } from 'react'
import './content-box.css'
import logo from './assets/pokemon_logo.png'

export type ContentBoxProps = {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode;
};

function Header () {
  return (
    <header>
      <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      <div className='logo-wrapper'>
        <img className='logo' src={logo} alt={'Pokémon'} />
      </div>
    </header>
  )
}

export function ContentBox ({ children }: ContentBoxProps) {
  return (
    <div className='base-container-border'>
      <Header />
      {children}
    </div>
  )
}
